import { render } from "./PageNumListItem.vue?vue&type=template&id=55161bc2&scoped=true"
import script from "./PageNumListItem.vue?vue&type=script&lang=js"
export * from "./PageNumListItem.vue?vue&type=script&lang=js"

import "./PageNumListItem.vue?vue&type=style&index=0&id=55161bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55161bc2"]])

export default __exports__